import React from 'react'
import { View } from 'react-native'
import moment from 'moment'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Button } from '@src/components/base'
import { EhrSlot } from '@src/types'

interface TimeSlotProps {
  slot: EhrSlot
  isSelected: boolean
  disabled?: boolean
  canConfirm?: boolean
  onSelect: (slot: EhrSlot) => void
  onConfirm: () => void
}

export const TimeSlot = ({
  slot,
  isSelected,
  disabled,
  canConfirm = true,
  onSelect,
  onConfirm,
}: TimeSlotProps) => {
  const styles = useStyleSheet(themedStyles)

  const time = moment(slot.time).format('hh:mm A')

  return (
    <View style={styles.slotItemContainer}>
      <Button
        style={[styles.slotButton, isSelected && styles.selectedSlotButton]}
        type="outline"
        onPress={() => onSelect(slot)}
        accessibilityLabel={`Select ${time} slot`}
        accessibilityState={{ selected: isSelected }}
        disabled={disabled}
        size="block"
      >
        {time}
      </Button>
      {isSelected && canConfirm && (
        <Button
          style={styles.slotButton}
          type="primary"
          onPress={onConfirm}
          accessibilityLabel="Confirm"
          disabled={disabled}
          size="block"
        >
          Confirm
        </Button>
      )}
    </View>
  )
}

const themedStyles = StyleService.create({
  slotItemContainer: {
    flex: 1,
    flexDirection: 'row',
    gap: 8,
  },
  slotButton: {
    flexGrow: 1,
  },
  selectedSlotButton: {
    backgroundColor: 'theme.background.selected',
    borderColor: 'theme.primary.base',
  },
})
